import { memo } from 'react'

import { Block, Done, Error, HourglassBottom, Loop, Pause } from '@mui/icons-material'

import { Chip, ChipProps } from '@collaborate-health/uikit'

import { CertificateStatusType, CertificateStatusTypeDisplayName } from '../../enums'

const CertificateStatusToColorMap: Record<CertificateStatusType, ChipProps['color']> = {
  [CertificateStatusType.Approved]: 'success',
  [CertificateStatusType.Rejected]: 'error',
  [CertificateStatusType.Obsolete]: 'error',
  [CertificateStatusType.Expired]: 'warning',
  [CertificateStatusType.PendingReview]: 'info',
  [CertificateStatusType.Processed]: 'info',
  [CertificateStatusType.Draft]: 'default',
}

const CertificateStatusToIconMap: Record<CertificateStatusType, ChipProps['icon']> = {
  [CertificateStatusType.Approved]: <Done />,
  [CertificateStatusType.Processed]: <Done />,
  [CertificateStatusType.Rejected]: <Block />,
  [CertificateStatusType.PendingReview]: <Loop />,
  [CertificateStatusType.Draft]: <Pause />,
  [CertificateStatusType.Obsolete]: <Error />,
  [CertificateStatusType.Expired]: <HourglassBottom />,
}

export interface CertificateStatusChipProps {
  status: CertificateStatusType
}

const CertificateStatusChip: React.FC<CertificateStatusChipProps> = ({ status }) => {
  const color = CertificateStatusToColorMap[status] || 'default'
  const icon = CertificateStatusToIconMap[status] || <HourglassBottom />

  return <Chip label={CertificateStatusTypeDisplayName[status]} size='small' color={color} icon={icon} />
}

export default memo(CertificateStatusChip)

